// Simple Flux implementation for dispatching actions across the app
let _lastId = 1;
const _prefix = 'ID_';

class Dispatcher {
	constructor() {
		this._callbacks = {};
		this._isDispatching = false;
		this._pendingPayload = null;
	}

	register(callback) {
		const id = _prefix + _lastId++;
		this._callbacks[id] = callback;
		return id;
	}

	dispatch(payload) {
		this._pendingPayload = payload;
		this._isDispatching = true;
		try {
			for (const id in this._callbacks) {
				this._callbacks[id](payload);
			}
		} finally {
			this._pendingPayload = null;
			this._isDispatching = false;
		}
	}
}

const AppDispatcher = new Dispatcher();

export default AppDispatcher;
